import React from "react";

const TestimonialCard = ({
  name = "NAME HERE",
  tagline,
  image,
  message,
  stars = 5,
  themeColor = "blue-600", // default color
  testimonial,
}) => {
  const [firstName, ...rest] = name.split(" ");
  const lastName = rest.join(" ");

  // Tailwind me dynamic color banana (with template strings)
  const borderClass = `border-${themeColor}`;
  const textColor = `text-${themeColor}`;
  const bgColor = `bg-${themeColor}`;

  return (
    <div className="max-w-md bg-white shadow-lg rounded-xl p-6 text-center relative overflow-hidden">
      {/* Left Box - centered vertically */}
      <div className={`absolute left-0 top-1/2 transform -translate-y-1/2 h-12 w-5 ${bgColor} rounded-r`} />

      {/* Right Box - centered vertically */}
      <div className={`absolute right-0 top-1/2 transform -translate-y-1/2 h-12 w-5 ${bgColor} rounded-l`} />

      {/* Profile Image */}
      <div className={`w-20 h-20 mx-auto mb-4 rounded-full overflow-hidden border-4 ${borderClass}`}>
        <img src={image} alt={name} className="object-cover w-full h-full" />
      </div>

      {/* Name */}
      <h3 className="text-2xl font-bold text-gray-800 ">
        {firstName} <span className={textColor}>{lastName}</span>
      </h3>

      {/* Tagline */}
      <p className={`text-sm ${textColor}`}>{tagline}</p>

      {/* Stars */}
      <div className="flex justify-center my-2">
        {Array(stars)
          .fill(0)
          .map((_, i) => (
            <span key={i} className={`${textColor} text-xl`}>★</span>
          ))}
      </div>

      {/* Message with colored quotes */}
      <p className="text-sm text-gray-600 italic mt-3">
        <span className={`${textColor}`}>“</span>
        {testimonial}
        <span className={`${textColor}`}>”</span>
      </p>
    </div>
  );
};

export default TestimonialCard;
